export default __webpack_public_path__ + "static/media/Question-icon.65121445.svg";